<template>
    <div class="row">
        <div class="col-xl-12 col-xs-12 align">
            <div class="credit align" v-if="user_credits">
                <span class="bold">{{user_credits}}</span>
                Credits remaining
            </div>
            <div class="credit align" v-if="!user_credits">
                You have no credits
            </div>
            <button @click="showModal" tag="button" class="btn btn-small content-right">Buy more credits</button>
        </div>
        <notifications group="foo" position="top right" />
        <modal
            v-show="isModalVisible"
            @close="closeModal"
            class="center-modal-content"
          >
            <h3 slot="header" class="header-modal">
                Purchase more enrichment credits
                <i @click="closeModal" class="fas fa-window-close ic" title="close"></i>
            </h3>

            <div slot="body">
                <div class="row bloque">
                    <div class="col-md-2 col-xs-2 bold hidden-xs">
                        {{this.numCommaFormat(value)}} credits <br />
                        <span class="small-text"> {{current_cost}}&#162; per credit </span>
                    </div>
                    <div class="col-xs-12 bold visible-xs m-b-30">
                        {{this.numCommaFormat(value)}} credits <br />
                        <span class="small-text"> {{current_cost}}&#162; per credit </span>
                    </div>
                    <div class="col-md-8 col-xs-12">
                        <vue-slider
                            v-model="value"
                            :dotSize = 14
                            :height = 4
                            :min = 100
                            :max = 100000
                            :marks="true"
                            :data="marks"
                            :hide-label="false"
                            :tooltip="'none'"
                            :process-style="{ backgroundColor: 'hsla(216.66666666666666, 100.00%, 49.41%, 1.00)' }" >
                            <template v-slot:dot="{ value, focus }">
                                <div :class="['custom-dot', { focus }]">
                                    <div class="inner-circle">
                                    </div>
                                </div>
                            </template>
                        </vue-slider>
                    </div>
                    <div class="col-md-2 col-xs-2 hidden-xs">
                      <p class="price"> ${{price}} </p>
                    </div>

                    <div class="col-md-2 col-xs-12 visible-xs m-t-30">
                      <p class="price"> ${{price}} </p>
                    </div>

                    <div class="col-md-12 col-xs-12 bloque margin-top" v-if="user_card">
                        <div class="radio">
                            <input type="radio" name="target" @click="changeUpdateInfo(true)"  value="user_card" :checked="updateInfo" />
                        </div>
                        <div class="card-content info_cont">
                            Your are currently paying with a <span class="bold">{{user_card.card.brand}}</span> ending in
                            <span class="bold">{{user_card.card.last4}}</span>
                        </div>
                    </div>
                    <div class="col-md-12 col-xs-12 bloque margin-top">
                        <div class="radio">
                            <input type="radio" name="target" v-if="hideUpdateCard !== 'billing'" @click="changeUpdateInfo(false)" value="different_card" :checked="!user_card" />
                            <input type="radio" name="target" v-if="hideUpdateCard === 'billing'" @click="closeModal" v-model="radio_value" value="different_card" />
                        </div>
                        <span class="bold"> Use a new card </span>
                    </div>
                    <div class="col-md-12 col-xs-12 full" v-if="!updateInfo">
                          <UpdateCardInfo type='modal' v-on:update="buyCredits($event)">
                            <div slot="title"></div>
                            <div slot="header"></div>
                            <div slot="footer"></div>
                          </UpdateCardInfo>
                    </div>

                </div>
            </div>

            <div slot="footer">
                <div class="row">
                    <div class="col-xl-12 col-xs-12 full">
                        <div v-if="updateInfo">
                          <flash-message class="large"></flash-message>
                          <div>
                            <input type="checkbox"  id="agreementCheckbox"  required>
                            <label for="agreementCheckbox">I agree to Orbitly.io's <a href="https://www.orbitly.io/terms-and-conditions" target="_blank">Terms of Service</a> and <a href="https://www.orbitly.io/privacy-policy" target="_blank">Policy</a>. </label>
                          </div>
                          <br>
                          <button class="btn btn-large bold" @click="buyCredits" :disabled="desable_button">
                              {{button_value}}
                          </button>
                        </div>
                        <!-- <div class="bloque">
                            <img src="@/assets/info-icon.svg"  class="icon radio" width="20" height="20"/>
                            <label class="w-form-label margin-top-text">
                              By submitting this form you authorize the use of this card to purchase Orbitly enrichment credits and agree to our
                              <a href="https://www.orbitly.io/terms-of-service/july-12-2018" class="link-a" target="_blank"> Terms and Conditions. </a>
                            </label>
                        </div> -->
                    </div>
                </div>
            </div>

        </modal>
    </div>
</template>

<script>

import modal from '@/components/Modal.vue'
import UpdateCardInfo from '@/components/UpdateCardInfo.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { mapMutations } from 'vuex'

export default {
  name: 'credit_info',
  components: {
    modal,
    VueSlider,
    UpdateCardInfo
  },
  mounted () {
    this.messageStorage.destroyAll()
    this.computePrice(this.value)
  },
  data () {
    return {
      value: this.$store.state.uploadedLeadList.computeCredits,
      radio_value: 'user_card',
      current_cost: 9,
      price: 0,
      hideUpdateCard: this.$route.name,
      max: this.$store.state.uploadedLeadList.max,
      desable_button: false,
      button_value: 'Buy credits',
      messageStorage: this.flash(),
      text: 'Verifying uploaded leads'
    }
  },
  methods: {
    ...mapMutations([
      'user/setAuthUser',
      'uploadedLeadList/modalState',
      'uploadedLeadList/changeCredits',
      'uploadedLeadList/changeMax',
      'uploadedLeadList/setFileData',
      'uploadedLeadList/setPending',
      'uploadedLeadList/setLeads',
      'uploadedLeadList/changeUpdateInfo',
      'user/setCredits'
    ]),
    changeUpdateInfo (val) {
      this['uploadedLeadList/changeUpdateInfo'](val)
    },
    reset_data () {
      this.desable_button = false
      this.button_value = 'Buy credits'
    },
    setData: function (data) {
      this['uploadedLeadList/setFileData'](data)
    },
    pollFunction: function () {
      var time = setInterval(function () {
        if (!this.pending) {
          clearInterval(time)
          this.setData({ file: false, state: 'default', credits: 0, text: this.text })
        } else {
          this.pollLeads()
        }
      }.bind(this), 5000)
    },
    pollLeads: function () {
      this.$http.get('/api/leads/pending_leads/' + this.pending).then((res) => {
        if (res.status === 200) {
          this['uploadedLeadList/setLeads'](res.data.leads)
          this['user/setCredits'](res.data.user_credits)
          this['uploadedLeadList/setPending'](false)
          this.$notify({
            group: 'foo',
            title: 'File upload',
            type: 'success',
            text: 'the file has been process correctly',
            duration: 10000
          })
          this.setData({ file: false, state: 'default', credits: 0, text: this.text })
        } else if (res.status === 202) {

        }
      }).catch((err) => {
        this.setData({ file: false, state: 'default', credits: 0, text: this.text })
        console.log(err)
      })
    },
    sendFiletoServer (file) {
      this.$http.post('/api/leads/upload_leads', file, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        progress (e) {
          if (e.lengthComputable) {
            let _progress = Math.round(e.loaded / e.total * 100)
            console.log(_progress)
          }
        }
      }).then((res) => {
        if (res.status === 200) {
          this.setData({ file: false, state: 'processing', credits: 0, text: res.data.message })
          this['uploadedLeadList/setPending'](res.data.pending_leads)
          this['user/setAuthUser'](res.data)
          this.pollFunction()
        } else if (res.status === 202) {
          this.setData({ file: file, state: 'main', credits: res.data.credits, text: this.text })
          let creditsYouNeed = this.credits - this.user_credits
          this['uploadedLeadList/changeCredits']({ 'total': creditsYouNeed, 'value': false })
        }
      }).catch((err) => {
        if (err.status === 402) {
          this.setData({ file: file, state: 'credits', credits: err.body.credits, text: this.text })
          let creditsYouNeed = this.credits - this.user_credits
          this['uploadedLeadList/changeCredits']({ 'total': creditsYouNeed, 'value': true })
        } else if (err.status === 400) {
          this.$notify({
            group: 'foo',
            title: 'error',
            type: 'error',
            text: 'Try uploading the file again',
            duration: 10000
          })
          this.setData({ file: false, state: 'default', credits: 0, text: this.text })
        }
      })
    },
    buyCredits () {
      if(agreementCheckbox.checked === false) return false;
      this.desable_button = true
      this.button_value = 'processing...'
      var data = {
        amount: this.price,
        credits: this.value
      }
      this.$http.post('/api/billing/buy_credits', data).then((res) => {
        dataLayer.push({
            'transactionId': Date.now() / 1000 | 0,
            'transactionAffiliation': 'orbitly.io',
            'transactionTotal': parseFloat( this.price .replace(/,/g,'')),
            "transactionProducts" : [
                {
                    "name" : 'credits',
                    "sku" : res.data.id,
                    "price" : parseFloat( this.price .replace(/,/g,'')),
                    "quantity" : 1,
                }
            ],
            "event" : "transactionComplete",
        });
        this['user/setAuthUser'](res.data)
        this.reset_data()
        this.messageStorage.destroyAll()
        this.closeModal()
        this.$notify({
          group: 'foo',
          title: 'Success',
          type: 'success',
          text: 'You have ' + this.value + ' more credits',
          duration: 10000
        })
        var hash = { 'amount': parseFloat( this.price .replace(/,/g,'')) }
        window.location.href = 'https://www.orbitly.io/thank-you?hash=' + btoa(JSON.stringify(hash))
        if (this.$router.currentRoute.name === 'lookup') {
          location.reload()
        }
        if (this.file) {
          this.sendFiletoServer(this.file)
        }
      }).catch((err) => {
        this.reset_data()
        this.messageStorage.destroyAll()
        this.messageStorage.flash(err.data.error, 'error')
      })
    },
    showModal () {
      this.radio_value = 'user_card'
      this.modalState(true)
      if (this.hideUpdateCard !== 'billing' && !this.user_card) {
        this.changeUpdateInfo(false)
      }
    },
    modalState (value) {
      this['uploadedLeadList/modalState'](value)
    },
    closeModal () {
      this.modalState(false)
      this.changeUpdateInfo(true)
    },
    changeCard () {
      // this.modalState(false)
      // this.$router.push({ name: 'billing' })
      this.changeUpdateInfo(true)
      this.modalState(true)
    },
    priceFormat (price) {
      return price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    numCommaFormat (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    computePrice (val) {
      this['uploadedLeadList/changeCredits']({ 'total': val, 'value': true })

      if (val < 500) {
        let price = val * 0.15
        this.current_cost = 15
        this.price = this.priceFormat(price)
      } else if (val >= 500 & val < 1000) {
        let price = val * 0.12
        this.current_cost = 12
        this.price = this.priceFormat(price)
      } else if (val >= 1000 & val < 2500) {
        let price = val * 0.1
        this.current_cost = 10
        this.price = this.priceFormat(price)
      } else if (val >= 2500 & val < 5000) {
        let price = val * 0.09
        this.current_cost = 9
        this.price = this.priceFormat(price)
      } else if (val >= 5000 & val < 10000) {
        let price = val * 0.08
        this.current_cost = 8
        this.price = this.priceFormat(price)
      } else if (val >= 10000 & val < 25000) {
        let price = val * 0.07
        this.current_cost = 7
        this.price = this.priceFormat(price)
      } else if (val >= 25000 & val < 100000) {
        let price = val * 0.06
        this.current_cost = 6
        this.price = this.priceFormat(price)
      } else if (val >= 100000) {
        let price = val * 0.05
        this.current_cost = 5
        this.price = this.priceFormat(price)
      }
    }
  },
  watch: {
    value: function (val) {
      this.computePrice(val)
    }
  },
  computed: {
    user_card: function () {
      return this.$store.state.user.data.stripe_obj
    },
    user_credits: function () {
      return this.$store.state.user.data.credits
    },
    isModalVisible: function () {
      return this.$store.state.uploadedLeadList.isModalVisible
    },
    file: function () {
      return this.$store.state.uploadedLeadList.file
    },
    credits: function () {
      return this.$store.state.uploadedLeadList.fileCredits
    },
    pending: function () {
      return this.$store.state.uploadedLeadList.id_pending
    },
    marks: function () {
      return this.$store.state.uploadedLeadList.marks
    },
    updateInfo: function () {
      return this.$store.state.uploadedLeadList.updateInfo
    }
  }
}
</script>

<style lang="scss">

.small-text {
  font-size: 10px;
}

.link-a {
  text-decoration: none;
}

.full {
  width: 100%;
  margin-left: 15px;

}
.align {
    display: inline-block;
}
.ic {
    display: inline-block;
    float: right;
    cursor: pointer;
    color: $color-1;
}
.custom-dot {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid $color-1;
    background-color: white;
    transition: all .3s;
}
input[type='radio']:hover {
    cursor: pointer;
}
input[type='radio'] {
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    outline: none;
    border: 2px solid $color-1;
}
input[type='radio']:before {
    content: '';
    display: block;
    width: 50%;
    height: 50%;
    margin: 25% auto;
    border-radius: 50%;
}
input[type="radio"]:checked:before {
    background: $color-1;
}
.info_cont {
    text-align: left;
    width: 95%;
    height: 20px;
}
input[type="radio"]:checked {
    border-color:$color-1;
}
.header-modal {
    justify-content: center;
    text-align: center;
    margin-bottom: 40px;
}
.radio {
    margin-right: 10px;
}
.margin-top {
    margin-top: 30px;
}
.margin-top-text {
    margin-top: 5px;
}
.bloque {
    display: inline-flex;
    -ms-flex-align: center !important;
    align-items: center !important;
}
.center-modal-content {
    justify-content: center;
}
.price {
    font-weight: bold;
    font-size: 18px;
    padding-left: 18px;
}
.inner-circle {
    width: 50%;
    height: 50%;
    border-radius: 50%;
    border: 1px solid $color-1;
    background-color: white;
    transform: translate(30%, 30%);
}
</style>
